export let PhoneRequirement;

(function (PhoneRequirement) {
  PhoneRequirement["Disabled"] = "disabled";
  PhoneRequirement["Optional"] = "optional";
  PhoneRequirement["Mandatory"] = "mandatory";
})(PhoneRequirement || (PhoneRequirement = {}));

export let ShippingContactType;

(function (ShippingContactType) {
  ShippingContactType["ShippingLabel"] = "shipping_label";
  ShippingContactType["DigitalLabel"] = "digital_label";
  ShippingContactType["ReturnLabel"] = "return_label";
  ShippingContactType["Buyer"] = "buyer";
  ShippingContactType["Seller"] = "seller";
})(ShippingContactType || (ShippingContactType = {}));